import {request} from "./request";
// 产品与服务
export function getProductService() {
  return request({
    url:'/productService/list',
    methods:'get',
  })
}
// 首页推荐新闻
export function getHotNews() {
  return request({
    url:'/news/tuijian',
    methods:'get',
  })
}


export function getBanners() {
  return request({
    url:'/banner/list',
    methods:'get',
  })
}

export function contactAdd(data = {}) {
  return request({
    url: '/contact/add',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/network/index.js